import { createActions } from 'redux-actions';

export const { setLayoutFeature } = createActions('SET_LAYOUT_FEATURE');

export const { talentNetworkHeroCtaClicked, claimYourProfileHeroCtaClicked, wlcGetroLogoClicked } = createActions(
  'TALENT_NETWORK_HERO_CTA_CLICKED',
  'CLAIM_YOUR_PROFILE_HERO_CTA_CLICKED',
  'WLC_GETRO_LOGO_CLICKED',
);
